import {
  TableColumns,
  TableFilterTab,
} from '../../../../../../ui-components/lib/table/table.model';
import { ActionList } from '../../../../../common/models/action-list.model';

export const GROUP_LIST_COLUMNS: TableColumns[] = [
  { header: '' },
  {
    header: 'group_list_screen_group_header_title',
    showViewIcon: true,
  },
  {
    header: 'group_list_screen_total_users_header_title',
  },
  {
    header: 'group_list_screen_status_header_title',
  },
  { header: '' },
];

export const GROUP_LIST_COLUMNS_SORT: TableColumns[] = [
  { header: '' },
  {
    header: 'group_list_screen_group_header_title',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header: 'group_list_screen_total_users_header_title',
    isSortable: true,
    sortKey: 'users_count][type',
  },
  {
    header: 'group_list_screen_status_header_title',
    isSortable: true,
    sortKey: 'state][type',
  },
  { header: '' },
];

export const GROUP_LIST_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
  routerLinks: [],
};

export const GROUP_LIST_EDIT_ACTION: ActionList = {
  key: 'edit',
  hasIcon: true,
  label: 'edit_action_item',
  hasDivider: true,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
  routerLinks: [],
};

export const GROUP_LIST_DEACTIVATE_ACTION: ActionList = {
  key: 'deactivate',
  hasIcon: true,
  label: 'group_list_screen_deactivate_group_action_item',
  hasDivider: false,
  labelCustomStyle: 'text-destructive-500',
  hasToggle: false,
};

export const GROUP_LIST_ACTIVATE_ACTION: ActionList = {
  key: 'activate',
  hasIcon: true,
  label: 'group_list_screen_activate_group_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
};

export const GROUP_LIST_DELETE_ACTION: ActionList = {
  key: 'delete',
  hasIcon: true,
  label: 'delete_action_item',
  hasDivider: false,
  labelCustomStyle: 'text-destructive-500',
  hasToggle: false,
};

export const GROUP_LIST_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'active',
    identifier: 'active',
    label: 'table_filter_tab_active_label',
    active: false,
    iconName: 'active',
  },
  {
    key: 'inactive',
    identifier: 'inactive',
    label: 'table_filter_tab_inactive_label',
    active: false,
    iconName: 'inactive',
  },
];
